<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="page.title"
      :icon="page.icon"
      :breadcrumbs="breadcrumbs"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard heading="Embalagens">
          <listar-embalagem />
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ListarEmbalagem from '@/components/patio/ListarEmbalagem'
export default {
  data() {
    return {
      page: {
        title: 'Gerenciamento de embalagens',
      },
      breadcrumbs: [
        {
          text: 'Pátios',
          disabled: false,
          to: '/patio/patio',
        },
        {
          text: 'Embalagens',
          disabled: false,
        },
      ],
    }
  },
  components: {
    ListarEmbalagem,
  },
}
</script>

<style></style>
